import { useState } from 'react';
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Grid,
  Typography,
  FormControl,
  Modal,
} from "@mui/material";
import Logo from "../../assets/images/logo.png"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { makeStyles } from "@mui/styles";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { patchAPI, getAPI, postAPI } from '../network';
import Vmsheader from './vmsheader';

const theme = createTheme();

theme.typography.cmt = {
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: '700',
  color: '#96979C',
  fontFamily: 'Poppins',
  '@media (min-width:600px)': {
    fontSize: '14px',
    fontWeight: '700',
    color: '#96979C',
    fontFamily: 'Poppins',

  },
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
};

theme.typography.h2 = {
  backgroundColor: '#457B9D',
  color: 'white',
  fontSize: '14px',
  padding: '10px',
  borderRadius: '8px',
  fontWeight: 800,
  marginTop: '20px',

  '@media (min-width:600px)': {
    fontSize: '13px',
  },
}

function Profile() {
  const navigateTo = useNavigate();
  const [pro, setPro] = useState({});
  const [visitor, setVisitor] = useState({});
  const siteId = localStorage.getItem('siteId');
  const [inductionStatus, setInductionStatus] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [visitorStatus, setVisitorStatus] = useState(false)
  const [profile, setProfile] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    BName: '',
    position: '',
    lat: '',
    lng: '',
  });

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setProfile((prevState) => ({
            ...prevState,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }));
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            alert('Location permission is required to proceed. Please enable it in your browser settings.');
          }
        }
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  };

  const checkLocationPermission = async () => {
    if (!navigator.permissions) {
      getLocation(); // Fallback if permissions API is not supported
      return;
    }

    try {
      const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

      if (permissionStatus.state === 'granted') {
        getLocation();
      } else if (permissionStatus.state === 'prompt') {
        getLocation(); // Will ask for permission
      } else {
        alert('Location access is denied. Please enable location permissions in your browser settings.');
      }
    } catch (error) {
      console.error('Permission check error:', error);
      getLocation(); // Fallback
    }
  };

  useEffect(() => {
    const visitors = localStorage.getItem('visitor');
    if (visitors && visitors !== "undefined") {
      setVisitor(JSON?.parse(visitors));
    }
    getProfile();
    checkLocationPermission();
  }, []);

  const handleNavigate = () => {
    if (!profile.firstname) {
      toast.error('Please Enter Valid First Name');
    }
    if (!profile.lastname) {
      toast.error('Please Enter Valid Last Name');
    } else if (!profile.email) {
      toast.error('Please Enter Valid Email');
    } else if (!profile.phone) {
      toast.error('Please Enter Valid Phone');
    } else if (!profile.BName) {
      toast.error('Please Enter Valid Business Name');
    } else if (!profile.position) {
      toast.error('Please Enter Valid Role');
    } else if (!profile.lat || !profile.lng) {
      checkLocationPermission();
      toast.error('Location is required to proceed.');
    } else {
      updateProfile();
      if (!inductionStatus) {
        navigateTo(`/vms/induction`);
      } else if (!visitorStatus) {
        navigateTo(`/vms/visit`)
      } else {
        navigateTo(`/vms/task_&_Notify`)
      }
    }
  };

  const getProfile = async () => {
    try {
      let data = await getAPI('/visitor/profile/');
      if (data) {
        setPro(data);
        setProfile((prev) => ({
          ...prev,
          firstname: data?.firstname,
          lastname: data?.lastname,
          email: data?.email,
          phone: data?.phone?.toString(),
          BName: data?.company,
          position: data?.role,
        }));
        setVisitorStatus(data?.visitor)
        setInductionStatus(data?.induction)
        if (data?.induction) {
          setShowModal(true);
        }
        localStorage.setItem('email', data.email);
        localStorage.setItem('userId', data.id);
        localStorage.setItem('visitor', data?.visitor);
        localStorage.setItem('visitorType', data?.visitorType);
        localStorage.setItem('induction', data?.induction);
      }
    } catch (error) {
      console.log(error)

    }

  };

  const updateProfile = async () => {
    let payload = {
      firstname: profile.firstname,
      lastname: profile?.lastname,
      email: profile.email,
      phone: profile.phone,
      role: profile.position,
      company: profile.BName,
      siteId: siteId,
      lat: profile.lat,
      lng: profile.lng,
    };
    const data = await patchAPI(`/visitor/profile`, payload);
    if (!data.data) {
      const data = await postAPI(`/visitor/book/clockout`)
      if (data) {
        localStorage.clear();
        navigateTo(`/`)
      }
    }
    localStorage.setItem('email', profile.email);
    localStorage.setItem('profile', true);
  };
  return (
    <Grid sx={{ width: '100%', display: 'flex', justifyContent: "center", }}>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: 'column', width: '90%' }}>
        <Vmsheader />
        <img width='180px' height='180px' src={Logo} alt='empty'></img>

        <ThemeProvider theme={theme}>
          <Typography component="h6" variant="h5" className="title-font">Your Profile</Typography>

          <Typography component='h6' varient='' className='visit'>Please enter details below to complete your profile</Typography>

          <TextField className='hund box' id="outlined-basic" label="First Name" variant="outlined" value={profile.firstname}
            onChange={(data) => {
              setProfile(prevState => ({
                ...prevState,
                firstname: data.target.value,
              }))
            }}
          />
          <TextField className='hund box' id="outlined-basic" label="Last Name" variant="outlined" value={profile.lastname}
            onChange={(data) => {
              setProfile(prevState => ({
                ...prevState,
                lastname: data.target.value,
              }))
            }}
          />

          <TextField className='hund box' id="outlined-basic" label="Email" variant="outlined" value={profile.email}
            onChange={(data) => {
              setProfile(prevState => ({
                ...prevState,
                email: data.target.value,
              }))
            }}
            disabled
          />
          <TextField
            className="hund box"
            id="outlined-basic"
            label="Phone"
            variant="outlined"
            value={profile.phone}
            onChange={(data) => {
              const numericValue = data.target.value.replace(/[^0-9+]/g, ''); // Remove non-numeric characters
              setProfile((prevState) => ({
                ...prevState,
                phone: numericValue,
              }));
            }}
          />

          <TextField className='hund box' id="outlined-basic" label="Business Name" variant="outlined" value={profile.BName}
            onChange={(data) => {
              setProfile(prevState => ({
                ...prevState,
                BName: data.target.value,
              }))
            }}
          />
          <TextField className='hund box' id="outlined-basic" label="Position" variant="outlined" value={profile.position}
            onChange={(data) => {
              setProfile(prevState => ({
                ...prevState,
                position: data.target.value,
              }))
            }} />

          <Button variant="outlined" className='buttoRootA' onClick={handleNavigate}>
            Proceed
          </Button>
        </ThemeProvider>

      </Box>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Attention Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            You are re-checking into an existing site. Your check-in time and location will be updated to reflect the new entry.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setShowModal(false)}
            fullWidth
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Grid>
  )
}

export default Profile